import type { ProfileStore } from './interfaces'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

const getCurrentTime = (state: ProfileStore): string | null => state.options?.current_time ?? null
const getCurrentTimeSlotFrom = (state: ProfileStore): string | null => {
  const currentTime = getCurrentTime(state)
  if (!currentTime) return null
  return dayjs(currentTime, DateFormat.Default).startOf('hour').format(DateFormat.Default)
}
const getCurrentTimeSlotTo = (state: ProfileStore): string | null => {
  const slotFrom = getCurrentTimeSlotFrom(state)
  if (!slotFrom) return null
  return dayjs(slotFrom, DateFormat.Default).add(1, 'hour').subtract(1, 'minute').format(DateFormat.Default)
}
const getPrevTimeSlotFrom = (state: ProfileStore): string | null => {
  const slotFrom = getCurrentTimeSlotFrom(state)
  if (!slotFrom) return null
  return dayjs(slotFrom, DateFormat.Default).subtract(1, 'hour').format(DateFormat.Default)
}
const getPrevTimeSlotTo = (state: ProfileStore): string | null => {
  const slotFrom = getCurrentTimeSlotFrom(state)
  if (!slotFrom) return null
  return dayjs(slotFrom, DateFormat.Default).subtract(1, 'minute').format(DateFormat.Default)
}
const getNextTimeSlotFrom = (state: ProfileStore): string | null => {
  const slotFrom = getCurrentTimeSlotFrom(state)
  if (!slotFrom) return null
  return dayjs(slotFrom, DateFormat.Default).add(1, 'hour').format(DateFormat.Default)
}
const getNextTimeSlotTo = (state: ProfileStore): string | null => {
  const nextSlotFrom = getNextTimeSlotFrom(state)
  if (!nextSlotFrom) return null
  return dayjs(nextSlotFrom, DateFormat.Default).add(1, 'hour').subtract(1, 'minute').format(DateFormat.Default)
}

export const getters = {
  isLoading: (state: ProfileStore): ProfileStore['loading'] => state.loading,
  getUser: (state: ProfileStore): ProfileStore['user'] => state.user,
  getTimezone: (state: ProfileStore): string => state.user?.view_timezone ?? 'UTC',
  getCurrentTime: (state: ProfileStore): string | null => getCurrentTime(state),
  getCurrentTimeSlotFrom: (state: ProfileStore): string | null => getCurrentTimeSlotFrom(state),
  getCurrentTimeSlotTo: (state: ProfileStore): string | null => getCurrentTimeSlotTo(state),
  getPrevTimeSlotFrom: (state: ProfileStore): string | null => getPrevTimeSlotFrom(state),
  getPrevTimeSlotTo: (state: ProfileStore): string | null => getPrevTimeSlotTo(state),
  getNextTimeSlotFrom: (state: ProfileStore): string | null => getNextTimeSlotFrom(state),
  getNextTimeSlotTo: (state: ProfileStore): string | null => getNextTimeSlotTo(state),
  hasUser: (state: ProfileStore): boolean => !!state.user,
  isAvailable: (state: ProfileStore): boolean => state.user?.slot?.availability ?? false,
}
